export function handleActionModalResponse(response, redirectUrl) {
  const {errors, validation_errors} = response.data || {};

  if (validation_errors && validation_errors.length) {
    // self.$emit('vue-app-errors', response.data.validation_errors);
    $.notify('Please correct errors and try again!', 'warning');
    return false;
  } else if (errors) {
    if (errors.inactive_agent) {
      $.notify('You must enter an active agent code.', 'warning');
    } else if (errors.no_plan) {
      $.notify('You must subscribe to a plan. Redirecting to plans page.', 'warning');
      setTimeout(() => {
        window.location = '/plans';
      }, 1500);
    } else {
      $.notify(JSON.stringify(errors), 'warning');
    }
    return false;
  } else {
    $.notify('Success! Redirecting...', 'success');

    setTimeout(() => {
      if (window.location.pathname === redirectUrl) {
        console.log('reloading');
        window.location.reload();
      } else {
        window.location = redirectUrl;
        console.log('assigning');
      }
    }, 1500);

    return true;
  }
}
